import React, {Component} from "react";
import classNames from 'classnames';

import '../../../assets/sass/global/asides/aside-base.scss';


/**
 * Aside bar shown on the right of the layout.
 */
class AsideBase extends Component {
    /**
     * Renders the base aside.
     * @returns {React.ReactNode} The aside component.
     */
    render = () => {
        const asideClasses = this.asideClasses();
        return (
            <div className={classNames("aside-base", asideClasses)}>
                <div className="aside-header"> {this.renderHeader()} </div>
                <div className="aside-body"> {this.renderBody()}</div>
            </div>
        )
    };

    /**
     * Renders the header of the aside component.
     * @returns {React.ReactNode} The aside header.
     */
    renderHeader = () => undefined;

    /**
     * Renders the body of the aside component.
     * @returns {React.ReactNode} The aside body.
     */
    renderBody = () => undefined;
}

export default AsideBase;
